import {Provider} from "../systeminterfaces/provider.mjs";

class BanSearchSuggestionEngineProvider extends Provider{
    constructor(){
        super();

        this.banSearchDataSource;


    }
    configure(banSearchDataSource){
        this.banSearchDataSource = banSearchDataSource;
    }

    get(){
        var banSearchDataSource = this.banSearchDataSource;
        var banSuggestionEngine = function(limit){
            var search = (query, callback) => {
                if (!query.trim().length) return;
                banSearchDataSource.get(query)  // TMP Should be banLib.search() (use the current config )
                    .then((data)=>{
                        console.log('#',data);
                        var features = data.features;
                        return features;
                    })
                    .then((data)=>{
                        if (limit) data.splice(limit);
                        console.log('##',data)
                        return data;
                    })
                    .then(callback);
            }
            return search;
        };

        return banSuggestionEngine;
    }

}

export var banSearchSuggestionEngineProvider = new BanSearchSuggestionEngineProvider();